import React from 'react';

import { IconButton } from '@material-ui/core';
import { Cancel, CheckCircle } from '@material-ui/icons';
import { useSelector } from 'react-redux';

function Expertise({ userSubTopics, verifyExpertise }) {
  const { themes, topics, subTopics } = useSelector(
    ({ themeReducer }) => themeReducer
  );

  return (
    <>
      <div className='border border-gray-300 rounded-lg col-span-3'>
        <div className='bg-gray-200 py-2 px-4'>Expertise</div>

        <RenderExpertiseList
          themes={themes}
          topics={topics}
          subTopics={subTopics}
          userSubTopics={userSubTopics}
          verifyExpertise={verifyExpertise}
        />
      </div>
    </>
  );
}

const RenderExpertiseList = ({
  themes,
  topics,
  subTopics,
  userSubTopics,
  verifyExpertise,
}) => {
  const currentSubTopics = userSubTopics.map(({ subTopicId, status }) => {
    const st = subTopics.find((subTopic) => subTopic.id === subTopicId) || [];
    const topicId = st.topicId;
    const t = topics.find((topic) => topic.id === topicId) || [];
    const themeId = t.themeId;
    return {
      themeId,
      topicId,
      subTopicId,
      status,
    };
  });

  let count = 1;

  return (
    <div className='p-4 flex flex-col gap-4'>
      {themes.map(
        ({ id, name, topics }) =>
          currentSubTopics.find(({ themeId }) => themeId === id) && (
            <div key={id}>
              <div className='text-gray-600 font-bold text-lg ml-4'>{name}</div>
              <div className='flex flex-col gap-2'>
                {topics.map(
                  ({ id, name, subTopics }) =>
                    currentSubTopics.find(({ topicId }) => topicId === id) && (
                      <div key={id}>
                        <div className='text-green-700 font-semibold py-1 ml-4'>
                          {name}
                        </div>

                        <div className='flex flex-col gap-1'>
                          {subTopics.map(({ id, name }) => {
                            const userSubTopic = currentSubTopics.find(
                              ({ subTopicId }) => subTopicId === id
                            );
                            if (userSubTopic)
                              return (
                                <div className='relative pb-1 ml-4' key={id}>
                                  <span>{name}</span>

                                  {userSubTopic.status && (
                                    <span className='absolute right-0 w-1/5'>
                                      <div className='flex items-center justify-between'>
                                        <span>Expertise {count++}</span>
                                        <span className='flex gap-4'>
                                          <IconButton
                                            onClick={() =>
                                              verifyExpertise(
                                                userSubTopic,
                                                'approve'
                                              )
                                            }
                                            className='focus:outline-none'
                                            size='small'
                                          >
                                            <CheckCircle
                                              htmlColor={
                                                userSubTopic.status ===
                                                'APPROVED'
                                                  ? '#76CE65'
                                                  : 'inherit'
                                              }
                                            />
                                          </IconButton>
                                          <IconButton
                                            onClick={() =>
                                              verifyExpertise(
                                                userSubTopic,
                                                'delete'
                                              )
                                            }
                                            className='focus:outline-none'
                                            size='small'
                                          >
                                            <Cancel />
                                          </IconButton>
                                        </span>
                                      </div>
                                    </span>
                                  )}
                                </div>
                              );
                            return null;
                          })}
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          )
      )}
    </div>
  );
};

export default Expertise;
